module.exports = __webpack_public_path__ + "img/chart-faaliyet-kar.5375b652.png";